export default ".outer-container {\n  max-width: 600px;\n}";